import { useState } from 'react';
import { useMutation } from 'react-query';

import { MOBILE_FULLSCREEN } from '@core/constants/ModalTypes';
import CartCarousel from '@core/components/cartcarousel/CartCarousel';
import Menu from '@core/components/dropDownMenu/Menu';
import UseModal from 'hooks/use-modal';

import { ContentCertificatePdfService } from 'services/core';

import Modal from '@core/components/Modal/Modal';
import SurveyCertificateWrapper from 'components/pages/lecture/lecturemainbutton/surveycertificatewrapper/SurveyCertificateWrapper';


import DownloadIcon from 'assets/icons/download-icon.svg';
import LinkIcon from 'assets/icons/link-icon.svg';
import VerticalDotsIcon from 'assets/icons/vertical-dots-icon.svg';
import BlurredCertificateImage from 'assets/images/pages/user-dashboard/course-certificate-blurred.png';

import classes from './Certificate.module.scss';

const Certificate = ({ section, origin }) => {
	const [selectedCertificateLectureId, setSelectedCertificateLectureId] = useState(null);
	const { mutate } = useMutation(ContentCertificatePdfService);
	const getLink = (id) => {
		mutate(id, {
			onSuccess: (data) => {
				location.href = data.data.certificate;
			}
		});
	};
	const copyToCLipboard = async (thubmnail_id) => {
		await navigator.clipboard.writeText(thubmnail_id);
	};

	const {
		show: certificateModalVisible,
		showModal: certificateShowModal,
		destroyModal: certificateDestroyModal
	} = UseModal();

	const downloadHandler = (certificate) => {
		if (certificate.certificate_id)
			getLink(certificate.certificate_id);
		else
		{
			setSelectedCertificateLectureId(certificate.lecture_id);
			certificateShowModal();
		}
			
	};

	return (
		<>
			{section.results.length !== 0 && (
				<CartCarousel section={section} origin={origin}>
					<section className={`${classes['certificate-container']} pb-5`}>
						{section.results.map((item) => (
							<>
								<div key={item.certificate_id} className={classes['certificate-card']}>
									<div className={classes['image']}>
										<img alt="" src={item.certificate_thumbnail ? item.certificate_thumbnail : BlurredCertificateImage.src} />
									</div>
									<div className={classes['info']}>
										<aside className={classes['left-side']}>
											<h1 className={classes['header']}>{item.title}</h1>
											<p className={classes['sub-header']}>
												{item.certificate_generated_at ? `Generated on ${item.certificate_generated_at}` : 'Ready to generate'}
											</p>
										</aside>
										<aside className={classes['right-side']}>
											<Menu
												icon={<VerticalDotsIcon />}
												menus={[
													{
														label: 'Download',
														link: false,
														icon: <DownloadIcon />,
														callback: () => downloadHandler(item)
													},
													...(item.certificate_id ? [{
														label: 'Copy Link',
														link: false,
														icon: <LinkIcon />,
														callback: () => copyToCLipboard(item.certificate_thumbnail)
													}] : [])
												]}
											></Menu>
										</aside>
									</div>
								</div>
							</>
						))}
					</section>
				</CartCarousel>
			)}

			<Modal
				type={MOBILE_FULLSCREEN}
				closeHandler={certificateDestroyModal}
				show={certificateModalVisible}
				backgroundColor='#FFF5E5'
			>
				<SurveyCertificateWrapper lectureId={selectedCertificateLectureId} />
			</Modal>
		</>
	);
};

export default Certificate;
